import React from 'react'
import './catalog.css'
const Catalog = () => {
    return (
        <>
            <div id='catalog' className=''>
                <div className="container-fluid">
                    <div className="first">
                        <h3>Catalogue</h3>
                    </div>
                    <div className='s-wrap'>
                        <div class="search-box-1">

                            <input type="text" placeholder='Search here' />
                        </div>
                        <button type="submit" class="my-btn-2 text-white hover-shadow ripple " style={{ background: "rgba(128, 0, 128, 0.81)" }}>search here</button>
                    </div>
                </div>






            </div>
            <div className="container">

                <div className="grid-of">
                    <div>
                        <div >
                            <img className='img-fluid' src="./images/Foodcardwallet/Pizza_Hut.svg" alt="" />
                            <div className='cf-wrap'>
                                <div className='sm-bx-1'><h2>+</h2></div>
                                <div className='sm-bx-2'><h2>-</h2></div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div >
                            <img className='img-fluid' src="./images/Foodcardwallet/Pizza_Hut.svg" alt="" />
                            <div className='cf-wrap'>
                                <div className='sm-bx-1'><h2>+</h2></div>
                                <div className='sm-bx-2'><h2>-</h2></div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div >
                            <img className='img-fluid' src="./images/Foodcardwallet/Pizza_Hut.svg" alt="" />
                            <div className='cf-wrap'>
                                <div className='sm-bx-1'><h2>+</h2></div>
                                <div className='sm-bx-2'><h2>-</h2></div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div >
                            <img className='img-fluid' src="./images/Foodcardwallet/Pizza_Hut.svg" alt="" />
                            <div className='cf-wrap'>
                                <div className='sm-bx-1'><h2>+</h2></div>
                                <div className='sm-bx-2'><h2>-</h2></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="grid-of">
                    <div>
                        <div >
                            <img className='img-fluid' src="./images/Foodcardwallet/Pizza_Hut.svg" alt="" />
                            <div className='cf-wrap'>
                                <div className='sm-bx-1'><h2>+</h2></div>
                                <div className='sm-bx-2'><h2>-</h2></div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div >
                            <img className='img-fluid' src="./images/Foodcardwallet/Pizza_Hut.svg" alt="" />
                            <div className='cf-wrap'>
                                <div className='sm-bx-1'><h2>+</h2></div>
                                <div className='sm-bx-2'><h2>-</h2></div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div >
                            <img className='img-fluid' src="./images/Foodcardwallet/Pizza_Hut.svg" alt="" />
                            <div className='cf-wrap'>
                                <div className='sm-bx-1'><h2>+</h2></div>
                                <div className='sm-bx-2'><h2>-</h2></div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div >
                            <img className='img-fluid' src="./images/Foodcardwallet/Pizza_Hut.svg" alt="" />
                            <div className='cf-wrap'>
                                <div className='sm-bx-1'><h2>+</h2></div>
                                <div className='sm-bx-2'><h2>-</h2></div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </>
    )
}

export default Catalog